export default __webpack_public_path__ + "static/media/0.8877b785.jpg";